import React, { useContext, useEffect, useMemo, useRef } from "react";
import {
  Marker,
  useMap
} from 'react-leaflet';

import "react-leaflet-fullscreen/styles.css";

import { AccountContext } from '../context/account';
import { MapDataContext } from '../context/map-data';
import { createMarkerIcon } from '../helpers/marker-icons';


interface MapPopUpModalProps {
  // currentFeature?: FeatureCollection | null
  onClose: () => void
}

export const MapPopUpModal = ({
  // currentFeature,
  onClose
}: MapPopUpModalProps) => {
  const markerRef = useRef(null)

  const map = useMap();

  const {
    projects,
  } = useContext(AccountContext);

  const {
    meshDataGeoJson, 
    setCurrentFeature,
    setMeshDataGeoJson,
    updateMeshData,
    setMapCenter,
  } = useContext(MapDataContext);

  useEffect(() => {
    if (map) {
      map.on('popupclose', () => {
        setCurrentFeature(null)
        setMeshDataGeoJson(null)      
        onClose()
      });
    }
  }, [map])
  

  useEffect(() => {
    const marker = markerRef.current
		if (marker) {
      // @ts-ignore
			marker.openPopup()
		}
    return () => {
      markerRef.current = null;
    }
  }, [meshDataGeoJson, markerRef])

  const position = useMemo((): [number, number] | null => {
    if (meshDataGeoJson 
      && meshDataGeoJson.features 
      && Array.isArray(meshDataGeoJson.features)
      && meshDataGeoJson.features.length > 0
    ) {
      const LatLonText = meshDataGeoJson.features[0].properties?.coords || null
      if (LatLonText) {
        const [lat, lon] = LatLonText.split(' ')
        return [Number(lat), Number(lon)]
      }
    }
    return null
  }, [meshDataGeoJson])

  const show = !!(meshDataGeoJson && position !== null && Array.isArray(position) && position.length === 2)

  const iconColor = useMemo(() => {
    if (projects 
      && Array.isArray(projects)
      && meshDataGeoJson 
      && meshDataGeoJson.features 
      && Array.isArray(meshDataGeoJson.features)
      && meshDataGeoJson.features.length > 0
    ) {
      const {model, provider, geography, version, coords} = meshDataGeoJson.features[0].properties || {}
      if (model && provider && geography && coords) {
        const [lat, lon] = coords.split(' ')
        const found = projects.find((item) => {
          return (
            item.model === model
            && item.provider === provider
            && item.geography === geography
            && item.version === version
            && Number(item.lat) === Number(lat)
            && Number(item.lon) === Number(lon)
          )
        })
        if (found) {
          return model === 'swan' ? 'wavegreenhighlight' : 'levelgreenhighlight' 
        }
      }
    }
    return 'blue'
  }, [JSON.stringify(projects), JSON.stringify(meshDataGeoJson)])

  return (
    <>
      <Marker
        opacity={show ? 1 : 0} 
        icon={createMarkerIcon(iconColor)} 
        ref={markerRef} 
        position={position === null ? [0,0] : position} 
        zIndexOffset={1000}
        eventHandlers={{
          click: (e) => {
            if (position && Array.isArray(position)) {
              const [lat, lon] = position
              updateMeshData({coords: `${lat}, ${lon}`})
              setMapCenter({location: {lat, lng: lon}})  
            }
          },
        }}
      />
    </>
  )
}
